import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Invite Flow Layout Route
 * Public parent route for handling invitation tokens via ?token= query param
 * Normalizes token from query params and passes control to child invite routes via Outlet.
 */
export const Route = createFileRoute('/_public/invite')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: Outlet,
});
